import { useCallback, useState } from 'react';

import Dialog from "@ergeon/core-components/exports/Dialog.ts";
import PopUp from "@ergeon/core-components/exports/PopUp.ts";

import Layout from '@/app/Layout';

import { IconHeart } from '@ergeon/icons/react';

interface EndCallPageProps {
  // True when the call closed itself after being left empty, rather than being
  // ended by the person now reading this.
  wasAbandoned?: boolean;
}

export default function EndCallPage({ wasAbandoned = false }: EndCallPageProps) {
  const [isVisible, setIsVisible] = useState(wasAbandoned);

  const close = useCallback(() => setIsVisible(false), []);

  // A reload is the whole way back: it returns to the lobby for the same meeting
  // hash, with devices re-checked and a fresh channel join. Rebuilding that in
  // place would mean unwinding state the call teardown has already discarded.
  const onRejoin = useCallback(() => window.location.reload(), []);

  return (
    <Layout>
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <IconHeart className="size-20 text-blue-500" />
        <h1 className="heading-3 text-center text-gray-900 dark:text-white">
          Thank you for the call!
        </h1>
      </div>
      <PopUp isVisible={isVisible} maxWidth="small" onChangeVisible={setIsVisible}>
        <Dialog
          hideCancelButton
          isVisible
          onDismiss={close}
          onSubmit={onRejoin}
          submitButtonFlavor="primary"
          submitButtonText="Rejoin the call"
          title="Call ended">
          <p className="paragraph-2">
            Nobody else was here for a while, so we closed the call. You can go
            back in if it is still going.
          </p>
        </Dialog>
      </PopUp>
    </Layout>
  );
}
